<script lang="ts" setup>
export type WidgetRatingColor = 'green'

export interface WidgetRatingProps {
    rating: number
    heading: string
    max?: number
    color?: WidgetRatingColor
    headingLevel?: string
}

const props = withDefaults(defineProps<WidgetRatingProps>(), {
    max: 5,
    color: 'green',
    headingLevel: 'h3',
})

const formatRating = (rating: number) => rating.toString().replace('.', ',')
</script>

<template>
  <aside
    class="bg-green-1 px-6 pt-6 pb-7 text-center text-lg-start rounded text-black"
    data-cy="widget_rating"
  >
    <Heading
      :level="props.headingLevel"
      class="fs-bigger fw-normal mb-3"
    >
      {{ props.heading }}
    </Heading>
    <div class="widget-rating-range mb-3 ms-md-1">
      <span class="widget-rating-range-number mb-0 me-1 fw-bold">
        {{ formatRating(props.rating) }}
      </span>
      {{ $t('z') }}
      <span class="widget-rating-range-number mb-0 ms-1 fw-bold">
        {{ formatRating(props.max) }}
      </span>
    </div>
    <Rating
      :rating="props.rating"
      :max="props.max"
    />
  </aside>
</template>

<style lang="scss" scoped>
@import './WidgetRating.scss';
</style>
